<i
  class="fa fa-folder-open"
  [class.root-node]="nodeType === 'hierarchy'"
  [class.campus-node]="nodeType === 'campus'"
  [class.region-node]="nodeType === 'region'"
></i>
